import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import isEqual from 'lodash.isequal';
import { Subscription } from 'rxjs';

import { SuccessStatusEnum } from '~/core/enums/success-status.enum';
import { Activity } from '~/core/model/activity.model';
import { Timeslot } from '~/core/model/timeslot.model';
import { OrganizerTimeslotEditionSharedSelectTimeslotsComponent } from '~/organizer/timeslot-edition/components/shared/select-timeslots/select-timeslots.component';
import { TimeslotUpdateService } from '~/organizer/timeslot-edition/services/timeslot-update.service';

@Component({
  selector:
    'app-organizer-timeslot-edition-update-offers-for-selected-timeslots',
  templateUrl: './update-offers-for-selected-timeslots.component.html',
})
export class OrganizerTimeslotEditionUpdateOffersForSelectedTimeslotsComponent
  implements OnInit, OnDestroy
{
  @ViewChild(OrganizerTimeslotEditionSharedSelectTimeslotsComponent)
  public child: OrganizerTimeslotEditionSharedSelectTimeslotsComponent;

  private readonly subscriptions = new Subscription();

  public activity: Activity;
  public selectedTimeslots = new FormControl();
  public timeslots: Timeslot[] = [];

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly timeslotUpdateService: TimeslotUpdateService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    const { upcomingTimeslotsData } = this.activatedRoute.snapshot.data;

    this.activity = upcomingTimeslotsData.activity;
    this.timeslots = upcomingTimeslotsData.upcomingTimeslots;

    this.selectedTimeslots.setValue({
      'select-all': false,
      timeslots: { [this.timeslots?.[0]?.identifier]: true },
    });
  }

  public get previousUrl(): string {
    return `/organizer.timeslot.manage/${this.timeslots?.[0]?.identifier}`;
  }

  private isUpdated(
    timeslot: Timeslot,
    partialTimeslot: Partial<Timeslot>
  ): boolean {
    return isEqual(timeslot.offers, partialTimeslot.offers);
  }

  public updateTimeslots(): void {
    this.child.isOverlayDisplayed = true;
    const timeslotsToUpdate = this.timeslotUpdateService.getTimeslotsToUpdate(
      this.selectedTimeslots,
      this.timeslots
    );

    this.subscriptions.add(
      this.timeslotUpdateService
        .updateTimeslots(this.activity.sku, timeslotsToUpdate, this.isUpdated)
        .subscribe(() => {
          this.child.overlayStatus = SuccessStatusEnum.SUCCESS;
        })
    );
  }
}
